import { Center, Spacer, HStack, Flex } from "@chakra-ui/react";
import Header from "./Header";
import { useMe } from "./api";
import { Link } from "react-router-dom";
import * as React from "react";

const Layout = ({
  children,
}: {
  children: React.ReactNode;
}): React.ReactNode => {
  const { isFetched: me_is_fetched } = useMe();

  if (!me_is_fetched) {
    return <></>;
  }

  return (
    <Flex direction="column" h="100vh" align="stretch" id="thar">
      <Header />

      <main style={{ flexGrow: 1 }}>{children}</main>

      <HStack mt="8" pb="4">
        <Spacer flexGrow="1" />
        <Center color="#aaaaaa">
          Website written by&nbsp;
          <Link to="https://rogersbrothers.biz/">Rogers Brothers</Link>
        </Center>
        <Spacer flexGrow="1" />
      </HStack>
    </Flex>
  );
};

export default Layout;
